<!--
 * @Author: wangjiaxiang
 * @Date: 2022-06-29 15:02:27
 * @LastEditTime: 2022-06-29 15:19:07
 * @LastEditors: wangjiaxiang
 * @Description: 内容详情组件
 * @FilePath: /xingmahui_front/src/views/contents/foodColumn/component/contentIntroduction.vue
 *
-->
<template>
  <div class="content-bg"  v-if="videoDetail.introduceImg.length > 0 || videoDetail.introduce">
    <div
      class="content-introduction"
    >
      <div class="title">内容简介</div>
      <div class="content">
        <p v-if="videoDetail.introduce">{{ videoDetail.introduce }}</p>
        <template v-if="videoDetail.introduceImg.length > 0">
          <img
            v-for="item in videoDetail.introduceImg"
            :src="item"
            alt="内容简介图片"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["videoDetail"],
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {},
};
</script>
<style lang="less" scoped>
// 内容简介
.content-bg{
  width: 100%;
  padding: 16px 16px 0;
  background: #F7F7F7;
}
.content-introduction {
  margin:auto 0;
  width: 343px;
  height: 100%;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  background: url("./../../../../assets/images/food/content_introduction.png");
  background-repeat: no-repeat;
  background-size: 100% 250px;
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    box-sizing: border-box;
    padding: 12px 0 12px 16px;
  }
  .content {
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    padding: 0 12px 10px 12px;
    p {
      font-size: 14px;
    }
    img {
      margin-top: 7px;
      width: 319px;
      border-radius: 8px;

      // height: 170px;
    }
  }
}
</style>
